
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogCategoryEN]",
      function () {
        return require("private-next-pages/[...blogCategoryEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogCategoryEN]"])
      });
    }
  